<template>
  <!-- Left Decoration -->
  <NuxtImg
    src="/hero-flowers-left.webp"
    alt="Hero Left Decoration"
    class="z-1 absolute left-0 bottom-[30%] w-[192px] flower-sway flower-left wind-1 sm:w-3xs sm:bottom-[25%] md:w-sm md:bottom-[8%] lg:bottom-[2%] lg:w-md xl:w-lg 2xl:w-xl"
    decoding="async"
    loading="eager"
    fetchpriority="high"
    :preload="{
      fetchPriority: 'high',
    }"
  />

  <!-- Right Decoration -->
  <NuxtImg
    src="/hero-flowers-right.webp"
    alt="Hero Right Decoration"
    class="z-1 absolute right-0 bottom-[15%] w-[192px] flower-sway flower-right wind-2 sm:w-3xs sm:bottom-[5%] md:w-xs md:bottom-0 lg:bottom-[5%] xl:w-md"
    decoding="async"
    loading="eager"
    fetchpriority="high"
    :preload="{
      fetchPriority: 'high',
    }"
  />
</template>
